var fs = require('./vendor/flexslider');
(function ($) {
	'use strict';

	$('.slider').flexslider({
		animation  : "slide",
		controlsContainer: ".slider",
		controlNav :	false,
		nextText: '<svg class="svg chevron-right" preserveaspectratio="xMinYMin meet" viewbox="0 0 512 512"><use xlink:href="#chevron" xmlns:xlink="http://www.w3.org/1999/xlink"></use></svg>'
  });

}(jQuery));
